<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{titleText}}</div>
    <div slot="body">
      <steps class="my-3" v-model="step" v-if="formType === 'create' || formType === 'clone'" />
      <template v-if="step.currentStep === 1">
        <!-- <dialog-selected-tips :name="$t('bill.text_210')" :count="suggestDatas.length" :action="actionText" /> -->
        <dialog-table class="mb-2" :data="suggestDatas" :columns="params.columns.filter(item => ['name', 'setting', 'tenant'].includes(item.field))" />
      </template>
      <a-form-model
        v-bind="formItemLayout"
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules">
        <template v-if="step.currentStep === 0">
          <a-form-model-item :label="$t('meter.scope_project')" prop="project_id">
            <base-select v-model="form.project_id" resource="projects" remote :disabled="formType === 'update'" :params="projectParams" />
          </a-form-model-item>
          <a-form-model-item :label="$t('meter.suggestion_rule')" prop="type">
            <base-select v-model="form.type" :options="showTypes" idKey="key" nameKey="label" :disabled="formType === 'update'" />
          </a-form-model-item>
          <a-form-model-item :label="$t('bill.text_73')" prop="resource_type">
            <base-select v-model="form.resource_type" :options="resourceTypes" idKey="key" nameKey="label" :disabled="formType === 'update'" />
          </a-form-model-item>
          <!-- 监控指标 -->
          <a-form-model-item v-if="form.type === types[1].key" :label="$t('monitor.monitor_metric')" prop="measurement">
            <div class="d-flex align-items-center">
              <base-select
                v-model="form.measurement"
                :options="measurements"
                idKey="fromItem"
                nameKey="fromItemLabel" />
              <base-select
                v-model="form.field"
                class="ml-2"
                :options="fields" />
              <base-select
                v-model="form.reduce_type"
                class="ml-2"
                :options="reduceTypes" />
            </div>
          </a-form-model-item>
          <!-- 条件 -->
          <a-form-model-item v-if="form.type === types[1].key" :label="$t('cloudenv.text_22')" prop="eval_type">
            <div class="d-flex align-items-center">
              <base-select
                v-model="form.eval_type"
                :selectStyle="{ minWidth: '80px' }"
                :options="evalTypes" />
              <a-input-number class="ml-2" v-model="form.threshold" :min="1" style="width:80px" />
              <span v-if="form.resource_type !== 'bucket'" class="ml-2">%</span>
            </div>
          </a-form-model-item>
          <a-form-model-item v-if="form.type === types[4].key" :label="$t('cloudenv.text_22')" prop="threshold">
            <div>
              <span v-if="form.resource_type === 'cloudaccount_amount_daily'">{{ $t('meter.suggest_rule.cloudaccount_amount_daily') }}</span>
              <span v-if="form.resource_type === 'cloudaccount_amount_month'">{{ $t('meter.suggest_rule.cloudaccount_amount_month') }}</span>
              <a-input-number class="ml-2" v-model="form.threshold" :min="100" style="width:80px" />
              <span class="ml-2">%</span>
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('meter.rule_name')" prop="name">
            <a-input v-model="form.name" :placeholder="$t('common.tips.input', [$t('meter.rule_name')])" />
          </a-form-model-item>
          <!-- 规则说明 -->
          <a-form-model-item v-if="form.type === types[0].key || form.type === types[2].key || form.type === types[3].key" :label="$t('meter.rule_desc')">
            {{ ruleDesc }}
          </a-form-model-item>
          <!-- 时间范围 -->
          <a-form-model-item :label="$t('bill.text_198')" prop="time_from">
            <div class="d-flex align-items-center">
              <span>{{ $t('meter.last') }}</span>
              <a-input-number class="ml-2" v-model="form.time_from" />
              <base-select
                class="ml-2"
                v-model="form.time_from_unit"
                :selectStyle="{ minWidth: '80px' }"
                :options="units"
                idKey="key"
                nameKey="label" />
              <template v-if="form.type === types[1].key">
                <a-checkbox class="ml-3" :checked="form.skip_holidays" @change="(e) => checkboxChange('skip_holidays', e)">{{ $t('meter.exclude_holidays') }}</a-checkbox>
                <a-checkbox class="ml-3" :checked="form.custom_time_range" @change="(e) => checkboxChange('custom_time_range', e)">{{ $t('meter.custom_time_range') }}</a-checkbox>
              </template>
            </div>
            <div class="d-flex mt-4" v-if="form.custom_time_range">
              <template>
                <a-time-picker v-model="form.custom_time_start" format="HH:mm" />
                <span class="ml-2 mr-2">~</span>
                <a-time-picker v-model="form.custom_time_end" format="HH:mm" />
              </template>
            </div>
          </a-form-model-item>
          <a-form-model-item :label="$t('bill.text_189')" prop="period">
            <div class="d-flex align-items-center">
              <a-input-number class="ml-2" v-model="form.period" />
              <base-select
                class="ml-2"
                v-model="form.period_unit"
                style="width:50px"
                :selectStyle="{ minWidth: '80px' }"
                :options="units.filter(item => ['h', 'd'].includes(item.key))"
                idKey="key"
                nameKey="label" />
            </div>
          </a-form-model-item>
          <!-- 优化方案 -->
          <a-form-model-item v-if="form.type !== types[1].key" :label="$t('meter.accuracy_method')">
            <span>{{ form.method || '-' }}</span>
          </a-form-model-item>
          <a-form-model-item v-else :label="$t('meter.accuracy_method')" prop="adjust_ratio">
            <a-radio-group v-model="form.adjust_ratio">
              <template v-if="this.form.resource_type === 'bucket'">
                <a-radio :value="100">{{ $t('meter.bucket_upgrade_100') }}</a-radio>
                <a-radio :value="-50">{{ $t('meter.bucket_downgrade_50') }}</a-radio>
                <a-radio :value="-99">{{ $t('meter.bucket_downgrade_99') }}</a-radio>
                <a-radio :value="-100">{{ $t('meter.bucket_downgrade_100') }}</a-radio>
              </template>
              <template v-else>
                <a-radio :value="100">{{ $t('meter.upgrade_100') }}</a-radio>
                <a-radio :value="-50">{{ $t('meter.downgrade_50') }}</a-radio>
                <a-radio :value="-100">{{ $t('meter.downgrade_100') }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="form.type === types[1].key" :label="$t('meter.cdf_chart')" />
          <cdf-chart v-if="form.type === types[1].key" :threshold="form.threshold" :measurement="form.measurement" :field="form.field" :eval_type="form.eval_type" />
        </template>
        <template v-if="step.currentStep === 1">
          <!-- 应用范围 -->
          <a-form-model-item :label="$t('common_101')" prop="scope_type">
            <a-radio-group v-model="form.scope_type" @change="handleScopeTypeChange">
              <template v-for="item of scopeTypeOptions">
                <a-radio-button :key="item.key" :value="item.key">{{ item.label }}</a-radio-button>
              </template>
            </a-radio-group>
          </a-form-model-item>
          <!-- 项目选择 -->
          <template v-if="shareProjectMode">
            <a-form-model-item :label="$t('dictionary.project')" prop="shared_projects">
              <template v-if="projectLoaded">
                <a-select
                  v-model="form.shared_projects"
                  mode="multiple"
                  :filterOption="false"
                  @search="fetchProjects"
                  @select="val => handleHasAllSelect(val, 'shared_projects')"
                  @deselect="val => handleDeselect(val, 'shared_projects')"
                  :placeholder="$t('rules.project')">
                  <template v-for="item of projects">
                    <a-select-option :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                  </template>
                </a-select>
              </template>
              <template v-else>
                <a-spin />
              </template>
            </a-form-model-item>
          </template>
          <!-- 域选择 -->
          <template v-if="shareDomainMode">
            <a-form-model-item :label="$t('dictionary.domain')" prop="shared_domains">
              <template v-if="domainLoaded">
                <a-select
                  v-model="form.shared_domains"
                  mode="multiple"
                  :filterOption="false"
                  @search="fetchDomains"
                  @select="val => handleHasAllSelect(val, 'shared_domains')"
                  @deselect="val => handleDeselect(val, 'shared_domains')"
                  :placeholder="$t('rules.domain')">
                  <template v-for="item of domains">
                    <a-select-option :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                  </template>
                </a-select>
              </template>
              <template v-else>
                <a-spin />
              </template>
            </a-form-model-item>
          </template>
        </template>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ okText }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'
import { hasSetupKey } from '@/utils/auth'
import {
  SUGGEST_RULE_TYPES,
  SUGGEST_RULE_RESOURCE_RULE_MAP,
  getSuggestRuleConfig,
  SUGGEST_RULE_TIME_FROM_UNIT,
  SUGGEST_RULE_METRIC,
  SUGGEST_RULE_METRIC_MAP,
} from '@Bill/constants'
import CdfChart from '../components/CdfChart'

export default {
  name: 'SuggestsysruleCreateDialog',
  components: {
    CdfChart,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    let form = {}
    if (this.params.type === 'clone' || this.params.type === 'update' || this.params.type === 'distribute') {
      form = this.getInitForm()
    }
    return {
      loading: false,
      R,
      form: {
        name: '',
        project_id: this.$store.getters.userInfo.projectId,
        type: this.params.ruleScope === 'cost' ? SUGGEST_RULE_TYPES[0].key : SUGGEST_RULE_TYPES[3].key,
        resource_type: undefined,
        time_from: 14,
        time_from_unit: 'd',
        period: 12,
        period_unit: 'h',
        method: '',
        measurement: undefined,
        field: '',
        reduce_type: 'avg',
        eval_type: '<',
        threshold: this.params.ruleScope === 'cost' ? 30 : 200,
        skip_holidays: false,
        custom_time_range: false,
        custom_time_start: null,
        custom_time_end: null,
        scope_type: 'none',
        shared_projects: [],
        shared_domains: [],
        ...form,
      },
      formType: this.params.type,
      rules: {
        project_id: [{ required: true, message: this.$t('common.tips.select', [this.$t('meter.scope_project')]) }],
        type: [{ required: true, message: this.$t('common.tips.select', [this.$t('meter.suggestion_rule')]) }],
        resource_type: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.text_73')]) }],
        name: [{ required: true, message: this.$t('common.tips.input', [this.$t('meter.rule_name')]) }],
        period: [{ required: true, message: this.$t('common.tips.input', [this.$t('bill.text_198')]) }],
        time_from: [{ required: true, message: this.$t('common.tips.input', [this.$t('bill.text_189')]) }],
        adjust_ratio: [{ required: true, message: this.$t('common.tips.select', [this.$t('meter.accuracy_method')]) }],
        measurement: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.form.measurement || !this.form.field) {
              callback(new Error(this.$t('common.tips.select', [this.$t('monitor.monitor_metric')])))
            }
            callback()
          },
        }],
        scope_type: [
          { required: false, message: this.$t('common_102') },
        ],
        shared_domains: [
          { required: true, message: this.$t('rules.domain') },
        ],
        shared_projects: [
          { required: true, message: this.$t('rules.project') },
        ],
        // unit: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.text_111')]) }],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      suggestData: this.params.data ? this.params.data[0] : {},
      unitOpts: [
        { key: 'h', label: this.$t('bill.text_4') },
        { key: 'd', label: this.$t('bill.text_3') },
      ],
      types: SUGGEST_RULE_TYPES,
      units: SUGGEST_RULE_TIME_FROM_UNIT,
      projectParams: {
        limit: 20,
        scope: this.$store.getters.scope,
      },
      domainLoaded: false,
      domains: [],
      projectLoaded: false,
      projects: [],
      step: {
        steps: [
          { title: this.$t('meter.set_rule'), key: 'create' },
          { title: this.$t('meter.set_scope') + `(${this.$t('bill.optional')})`, key: 'distribute' },
        ],
        currentStep: this.params.type === 'distribute' ? 1 : 0,
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo', 'l3PermissionEnable']),
    isCost () {
      return this.params.ruleScope === 'cost'
    },
    resourceTypes () {
      if (this.form.type) {
        return SUGGEST_RULE_RESOURCE_RULE_MAP[this.form.type]
      }
      return []
    },
    showTypes () {
      return this.isCost ? this.types.slice(0, 3).filter(item => {
        if (!hasSetupKey('public')) {
          return item.key !== 3
        }
        return true
      }) : this.types.slice(3, 5)
    },
    ruleDesc () {
      if (!this.form.resource_type) return '-'
      return getSuggestRuleConfig({ type: this.form.type, resource_type: this.form.resource_type }).desc || '-'
    },
    measurements () {
      const target = SUGGEST_RULE_METRIC.filter(item => item.resource_type === this.form.resource_type)
      return target.length ? target[0].metrics : []
    },
    fields () {
      if (this.form.resource_type === 'bucket') {
        return [
          { id: 'req_count', name: this.$t('monitor.text_118') },
        ]
      } else {
        const target = SUGGEST_RULE_METRIC_MAP[this.form.resource_type].metrics.filter(item => item.fromItem === this.form.measurement)
        return target.map(item => {
          return { id: item.seleteItem, name: this.$t('dashboard.text_80') }
        })
      }
    },
    reduceTypes () {
      return [
        { id: 'avg', name: this.$t('monitor.avg') },
        { id: 'min', name: this.$t('monitor.min') },
        { id: 'max', name: this.$t('monitor.max') },
      ]
    },
    evalTypes () {
      return [
        { id: '<', name: this.$t('compute.text_915') },
        { id: '>', name: this.$t('compute.text_916') },
      ]
    },
    suggestDatas () {
      return this.formType === 'create' ? [this.suggestData] : this.params.data
    },
    okText () {
      return this.step.currentStep === 0 && (this.formType === 'clone' || this.formType === 'create') ? this.$t('cloudenv.text_276') + `(${this.$t('bill.optional')})` : this.$t('dialog.ok')
    },
    // canEdit () {
    //   const { type } = this.suggestData
    //   const ret = {};
    //   (['threshold']).map(key => {
    //     if (ruleSupportEditMap[type] && ruleSupportEditMap[type].includes(key)) {
    //       ret[key] = true
    //     }
    //   })
    //   return ret
    // },
    // period_unit () {
    //   const target = this.unitOpts.filter(item => item.key === this.form.period_unit)
    //   return target.length ? target[0].label : this.form.period_unit || '-'
    // },
    // time_from_unit () {
    //   const target = this.unitOpts.filter(item => item.key === this.form.time_from_unit)
    //   return target.length ? target[0].label : this.form.time_from_unit || '-'
    // },
    titleText () {
      let text = this.$t('common_258')
      if (this.formType === 'update') text = this.$t('table.action.modify')
      if (this.formType === 'clone') text = this.$t('table.action.clone')
      if (this.formType === 'distribute') text = this.$t('meter.set_scope') + `(${this.$t('bill.optional')})`
      return text
    },
    actionText () {
      let text = this.$t('common_258')
      if (this.formType === 'update') text = this.$t('table.action.modify')
      if (this.formType === 'clone' && this.step.currentStep === 0) text = this.$t('table.action.clone')
      if (this.formType === 'distribute' || (this.formType === 'clone' && this.step.currentStep === 1)) text = this.$t('meter.set_scope') + `(${this.$t('bill.optional')})`
      return text
    },
    // domainParams () {
    //   return {
    //     scope: this.scope,
    //     limit: 20,
    //   }
    // },
    scopeTypeOptions () {
      const none = { key: 'none', label: this.$t('meter.current_project') }
      const project = { key: 'project', label: this.$t('meter.other_project') }
      const domain = { key: 'domain', label: this.$t('meter.scope_domain') }
      if (this.l3PermissionEnable && this.isAdminMode) {
        return [none, project, domain]
      }
      return [none, project]
    },
    noShareMode () {
      return this.form.scope_type === 'none'
    },
    shareDomainMode () {
      return this.form.scope_type === 'domain'
    },
    shareProjectMode () {
      return this.form.scope_type === 'project'
    },
  },
  watch: {
    'form.type' (val) {
      if (!this.resourceTypes.some(item => item.key === val)) {
        this.form.resource_type = this.resourceTypes[0].key
      }
      this.changeInitName()
    },
    'form.resource_type' (val) {
      this.changeInitName()
      this.form.measurement = undefined
      this.form.field = undefined
    },
    'form.eval_type' (val) {
      this.changeInitName()
    },
    'form.measurement' (val) {
      this.form.field = null
    },
    shareDomainMode: {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.fetchDomains()
          })
        }
      },
      immediate: true,
    },
    shareProjectMode: {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.fetchProjects()
          })
        }
      },
      immediate: true,
    },
  },
  created () {
    this.dm = new this.$Manager('domains', 'v1')
    this.pm = new this.$Manager('projects', 'v1')
    this.rm = new this.$Manager('suggestsysrules', 'v2')
  },
  methods: {
    async fetchDomains (query) {
      const params = {
        details: true,
        scope: this.scope,
        limit: 20,
      }
      if (query) {
        params.search = query
      }
      try {
        let data
        // 是否需要加入全部选项
        let needAll = true
        if (!this.isBatch && !this.params.noCandidateDomains) {
          data = await this.fetchChangeOwnerCandidateDomains(query)
          if (data.length > 0) {
            needAll = false
          }
          if (data.length === 0) {
            const response = await this.dm.list({
              params,
            })
            data = response.data.data || []
          }
        } else {
          const response = await this.dm.list({
            params,
          })
          data = response.data.data || []
        }
        if (!this.isBatch && this.params.data && this.params.data[0].shared_domains && this.params.data[0].shared_domains.length) {
          data = this.mergeSharedRes(data, this.params.data[0].shared_domains)
        }
        if (needAll) {
          data.unshift({ id: 'all', name: this.$t('common_95') })
        }
        this.domains = data
        this.domainLoaded = true
      } catch (error) {
        throw error
      }
    },
    // 获取可用的domain list
    async fetchChangeOwnerCandidateDomains (query) {
      const params = {
        scope: this.scope,
        details: true,
        limit: 0,
      }
      if (query) {
        params.search = query
      }
      try {
        const response = await this.rm.getSpecific({
          id: this.suggestDatas[0].id,
          spec: 'change-owner-candidate-domains',
        })
        const data = response.data.candidates || []
        return data
      } catch (error) {
        throw error
      }
    },
    async fetchProjects (query) {
      const params = {
        details: true,
        scope: this.scope,
        limit: 20,
        domain_id: this.suggestData?.domain_id,
        filter: `id.notin(${this.suggestData.tenant_id})`,
      }
      if (query) {
        params.search = query
      }
      try {
        const response = await this.pm.list({
          params,
        })
        let data = response.data.data || []
        if (this.suggestDatas[0].shared_projects && this.params.data[0].shared_projects.length) {
          data = this.mergeSharedRes(data, this.params.data[0].shared_projects)
        }
        data.unshift({ id: 'all', name: this.$t('common_95') })
        this.projects = data
        this.projectLoaded = true
      } catch (error) {
        throw error
      }
    },
    // 合并已共享的资源，这样可以实现name的反显，不会有先显示id的问题
    mergeSharedRes (data, sharedData) {
      const ret = [...data]
      if (sharedData && sharedData.length > 0) {
        R.forEach(value => {
          const obj = R.find(R.propEq('id', value.id))(ret)
          if (!obj) {
            ret.push(obj)
          }
        })
      }
      return ret
    },
    // 全部与选择项互斥交互
    handleHasAllSelect (val, field) {
      if (val === 'all') {
        this.form[field] = ['all']
        return
      }
      const newVal = [...this.form[field]]
      const allIndex = newVal.indexOf('all')
      const valIndex = newVal.indexOf(val)
      if (valIndex === -1) {
        newVal.push(val)
      }
      if (allIndex !== -1) {
        newVal.splice(allIndex, 1)
      }
      this.form[field] = newVal
    },
    // 取消选中
    handleDeselect (val, field) {
      const newVal = [...this.form[field]]
      const valIndex = newVal.indexOf(val)
      if (valIndex !== -1) {
        newVal.splice(valIndex, 1)
      }
      this.form[field] = newVal
    },
    genShareDomainsData (domains) {
      const ret = {
        scope: 'domain',
      }
      if (domains[0] === 'all') {
        ret.scope = 'system'
      } else {
        ret.shared_domains = domains
      }
      return ret
    },
    genShareProjectsData (projects) {
      const ret = {
        scope: 'project',
      }
      if (projects[0] === 'all') {
        if (this.l3PermissionEnable) {
          ret.scope = 'domain'
        } else {
          ret.scope = 'system'
        }
      } else {
        ret.shared_projects = projects
      }
      return ret
    },
    checkboxChange (key, e) {
      this.form[key] = e.target.checked
    },
    changeInitName () {
      const config = getSuggestRuleConfig({ type: this.form.type, resource_type: this.form.resource_type, eval_type: this.form.eval_type })
      this.form.name = config.name
      this.form.method = config.method
    },
    handleIdChange (val) {
      this.form.target_ids = val
    },
    getInitForm () {
      const form = {}
      const {
        name,
        tenant_id,
        type,
        res_type,
        time_from,
        period,
        skip_holidays,
        setting,
        time_range,
        adjust_ratio,
        is_public,
        public_scope,
        shared_projects,
        shared_domains,
      } = this.params.data[0]
      const config = getSuggestRuleConfig({ type, resource_type: type.includes('CLOUDACCOUNT_AMOUNT_') ? type.toLowerCase() : res_type })
      form.name = name
      form.project_id = tenant_id
      form.resource_type = type.includes('CLOUDACCOUNT_AMOUNT_') ? type.toLowerCase() : res_type
      if (type.includes('UP_DOWN_')) {
        form.type = SUGGEST_RULE_TYPES[1].key
        const { eval_type, measurement, field, threshold, reduce_type = 'avg' } = (setting ? setting.scale_rule[0] : {})
        form.measurement = measurement
        form.eval_type = eval_type
        form.field = field
        form.threshold = threshold
        form.reduce_type = reduce_type
        form.adjust_ratio = adjust_ratio
      } else if (type === 'UPGRADE_PREPAID') {
        form.type = SUGGEST_RULE_TYPES[2].key
        form.method = config.method
      } else if (type.includes('UNUSED_')) {
        form.type = SUGGEST_RULE_TYPES[0].key
        form.method = config.method
      } else if (type === 'OSS_SEC_ACL') {
        form.type = SUGGEST_RULE_TYPES[3].key
        form.method = config.method
      } else if (type.includes('CLOUDACCOUNT_AMOUNT_')) {
        form.type = SUGGEST_RULE_TYPES[4].key
        form.method = config.method
        const { rate = 2 } = setting?.cloud_account_amount || {}
        form.threshold = rate * 100
      }
      if (time_from) {
        form.time_from = Number(time_from.replace(/\D+/, ''))
        form.time_from_unit = time_from.replace(/\d+/, '')
      }
      if (period) {
        form.period = Number(period.replace(/\D+/, ''))
        form.period_unit = period.replace(/\d+/, '')
      }
      if (skip_holidays) {
        form.skip_holidays = true
      }
      if (time_range) {
        form.custom_time_range = true
        const list = time_range.split('-')
        form.custom_time_start = this.$moment(list[0], 'HH:mm')
        form.custom_time_end = this.$moment(list[1], 'HH:mm')
      }
      if (is_public) {
        // 当为部门共享时
        if (public_scope === 'system' && this.$store.getters.isAdminMode) {
          if (this.$store.getters.l3PermissionEnable) {
            form.scope_type = 'domain'
            // 域为空时，为全局共享
            if (R.isNil(shared_domains) || R.isEmpty(shared_domains)) {
              form.shared_domains = ['all']
            } else {
              form.shared_domains = shared_domains.map(item => item.id)
            }
          } else {
            form.scope_type = 'project'
            // 域为空时，为全局共享
            if (R.isNil(shared_projects) || R.isEmpty(shared_projects)) {
              form.shared_projects = ['all']
            } else {
              form.shared_projects = shared_projects.map(item => item.id)
            }
          }
        }
        // 为域共享时
        if (public_scope === 'domain') {
          form.scope_type = 'domain'
          // 未开启三级权限直接定位至不共享
          if (!this.$store.getters.l3PermissionEnable) {
            form.scope_type = 'none'
          }
          if (R.isNil(shared_domains) || R.isEmpty(shared_domains)) {
            form.scope_type = 'project'
            form.shared_projects = ['all']
          } else {
            form.shared_domains = shared_domains.map(item => item.id)
          }
        }
        // 为项目共享时
        if (public_scope === 'project') {
          form.scope_type = 'project'
          if (R.isNil(shared_projects) || R.isEmpty(shared_projects)) {
            form.shared_projects = ['all']
          } else {
            form.shared_projects = shared_projects.map(item => item.id)
          }
        }
      }
      return form
    },
    doUpdate (data) {
      return this.params.onManager('update', {
        id: this.params.data[0].id,
        managerArgs: {
          data,
        },
      })
    },
    doCreate (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    doSetScope (ids, data) {
      let action = 'private'
      if (this.shareDomainMode || this.shareProjectMode) action = 'public'
      return this.params.onManager('batchPerformAction', {
        id: ids,
        managerArgs: {
          action,
          data,
        },
      })
    },
    genParams () {
      let ret = {}
      const {
        project_id,
        type,
        name,
        resource_type,
        time_from_unit,
        time_from, period,
        period_unit,
        skip_holidays,
        custom_time_range,
        custom_time_start,
        custom_time_end,
        adjust_ratio,
        measurement,
        field,
        eval_type,
        reduce_type,
        threshold,
      } = this.form
      if ((this.formType === 'create' || this.formType === 'update' || this.formType === 'clone') && this.step.currentStep === 0) {
        ret.project_id = project_id
        ret.res_type = resource_type
        ret.name = name
        ret.time_from = `${time_from}${time_from_unit}`
        ret.period = `${period}${period_unit}`
        ret.type = getSuggestRuleConfig({ resource_type, type }).type
        if (type === SUGGEST_RULE_TYPES[1].key) {
          if (skip_holidays) {
            ret.skip_holidays = true
          }
          if (custom_time_range) {
            ret.time_range = `${custom_time_start.format('HH:ss')}-${custom_time_end.format('HH:ss')}`
          }
          ret.adjust_ratio = adjust_ratio
          const setting = {
            scale_rule: [],
          }
          const c = {
            database: 'telegraf',
            measurement,
            field,
            eval_type,
            reduce_type,
            threshold,
          }
          setting.scale_rule.push(c)
          ret.setting = setting
        }
        if (type === SUGGEST_RULE_TYPES[4].key) {
          const cloud_account_amount = {
            rate: threshold / 100,
            is_month: resource_type === 'cloudaccount_amount_month',
          }
          ret.setting = { cloud_account_amount }
          ret.res_type = 'cloudaccount'
        }
      }
      if (this.step.currentStep === 1) {
        // 设置域共享
        if (this.shareDomainMode) {
          ret = { ...ret, ...this.genShareDomainsData(this.form.shared_domains) }
        }
        // 设置项目共享
        if (this.shareProjectMode) {
          ret = { ...ret, ...this.genShareProjectsData(this.form.shared_projects) }
        }
      }
      return ret
    },
    updateSuggestData () {
      this.params.onManager('get', {
        id: this.suggestData.id,
        managerArgs: {
          params: { details: true },
        },
      }).then(res => {
        this.suggestData = res.data
        this.form = this.getInitForm(this.suggestData)
        this.step.currentStep = 1
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        if ((this.formType === 'create' || this.formType === 'clone') && this.step.currentStep === 0) {
          await validateModelForm(this.$refs.form)
          const values = this.genParams()
          const data = await this.doCreate(values)
          this.suggestData = data.data
          this.step.currentStep = 1
          this.loading = false
          this.params.refresh()
        } else if ((this.formType === 'create' || this.formType === 'clone' || this.formType === 'distribute') && this.step.currentStep === 1) {
          await validateModelForm(this.$refs.form)
          const values = this.genParams()
          await this.doSetScope([this.suggestData.id], values)
          // this.form = this.getInitForm(this.suggestData)
          this.loading = false
          this.params.refresh()
          this.cancelDialog()
        } else {
          await validateModelForm(this.$refs.form)
          const values = this.genParams()
          await this.doUpdate(values)
          this.step.currentStep = this.step.currentStep + 1
          // this.form = this.getInitForm(this.suggestData)
          this.loading = false
          this.params.refresh()
          this.cancelDialog()
        }
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
